export default __webpack_public_path__ + "static/media/Carlos_Erazo.48718403.png";